import login from "./loginSlice";
import house from "./houseSlice";


import { combineReducers } from 'redux';
import credit  from "./loanCredit";
export default combineReducers({
    login,
    house,
    credit
});
